import Link from "next/link";
import { ChevronRight } from "lucide-react";

type BreadcrumbItem = {
  label: string;
  href?: string;
};

type ServiceBreadcrumbsProps = {
  items: BreadcrumbItem[];
  className?: string;
};

export default function ServiceBreadcrumbs({
  items,
  className = "",
}: ServiceBreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className={className}>
      <ol className="flex flex-wrap items-center gap-2 text-sm text-primary-foreground/80">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.href && !isLast ? (
                <Link
                  href={item.href}
                  className="text-primary-foreground/80 hover:text-primary-foreground"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-primary-foreground font-medium">{item.label}</span>
              )}
              {!isLast && <ChevronRight className="w-4 h-4 text-primary-foreground/60" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
